export const VEHICLE_ID = 'veh1';
export const ADDRESS_ID = 'loc1';
export const ASSET_ID = 'asset1';
export const COVERAGE_ID = 'cov1';
export const DIFFERENT_ADDRESS_ID = 'adr-1';
export const PRIMARY_PARTY = 'Prt-0';
export const partyId = (idx: number) => `Prt-${idx + 1}`;
